"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pendingLivePollRule = exports.pollRules = void 0;
var date_1 = require("../utils/date");
var lodash_1 = require("lodash");
exports.pollRules = (0, lodash_1.sortBy)([
    {
        timeToStart: date_1.MILLISECONDS.ONE_HOUR,
        step: date_1.MILLISECONDS.ONE_MINUTE,
    },
    {
        timeToStart: date_1.MILLISECONDS.ONE_MINUTE * 5,
        step: date_1.MILLISECONDS.ONE_MINUTE / 6,
    },
    {
        timeToStart: -date_1.MILLISECONDS.ONE_MINUTE * 5,
        step: date_1.MILLISECONDS.ONE_MINUTE / 6,
    },
    {
        timeToStart: -date_1.MILLISECONDS.ONE_HOUR,
        step: date_1.MILLISECONDS.ONE_MINUTE / 2,
    },
], 'timeToStart');
exports.pendingLivePollRule = { step: date_1.MILLISECONDS.ONE_MINUTE / 20 };
//# sourceMappingURL=live-poll-rules.js.map